import { CgProfile } from "react-icons/cg";
import { TbReportAnalytics } from "react-icons/tb";
import {
    OverviewIcon,
    InsigthsIcon,
    CallLogo,
    MeetingRequestIcon,
    VideoEngagementIcon,
} from "./icons";
import VideoSettingsIcon from "@mui/icons-material/VideoSettings";

const arr = [
    {
        label: "Overview",
        to: "/",
        icon: <OverviewIcon style={{ fontSize: "22px" }} />,
    },
    {
        label: "Meeting requests",
        to: "/meeting-requests",
        icon: <MeetingRequestIcon style={{ fontSize: "22px" }} />,
    },
    {
        label: "Mentors",
        to: "/mentors",
        icon: <CgProfile style={{ fontSize: "22px" }} />,
    },
    {
        label: "Insights",
        to: "/insights",
        icon: <InsigthsIcon style={{ fontSize: "22px" }} />,
    },
    {
        label: "Calls",
        to: "/callOverview",
        icon: <CallLogo style={{ fontSize: "22px" }} />,
    },
    {
        label: "Leads",
        to: "/leads",
        icon: <CallLogo style={{ fontSize: "22px" }} />,
    },
    {
        label: "Emails",
        to: "/email",
        icon: <TbReportAnalytics style={{ fontSize: "22px" }} />,
    },
    {
        label: "Video Engagement",
        to: "/video-engagement",
        icon: <VideoEngagementIcon style={{ fontSize: "22px" }} />,
    },
    {
        label: "Video Workshop",
        to: "/video-workshop",
        icon: <VideoSettingsIcon style={{ fontSize: "22px" }} />,
    },
];
export default arr;
